




























































































































































import {Vue, Component, Provide} from 'vue-property-decorator';
import ShipCreate from '@/models/shipcreate';
import {Utils} from '@/utils/Utils';

@Component
export default class CreateShip extends Vue {
  shipName = '';
  shipImageName = '';
  shipImageURL = '';
  deckImageName = '';
  deckImageURL = '';

  shipImagebase64URL: any;
  commentOnShip = '';
  isActive1 = true;
  isActive2?: boolean;
  enable1 = true;
  enable2?: boolean;
  deckLength = 0;
  imageValidationMsg = '';
  shipValidationMsg = '';
  commonValidationMsg = 'This field is required';

  decks = [
    {
      deckName: '',
      deckImageName: this.deckImageName,
      deckImageURL: this.deckImageURL,
      heights: {
        h1: 0,
        h2: 0,
        h3: 0,
        h4: 0,
        h5: 0,
        h6: 0,
      },
    },
  ];

  async onFileChange(event: any, imageType: string) {
    const imageData = event.target.files[0];
    if (imageType === 'ship') {
      this.shipImageName = imageData.name;

      try {
        let base64url = await Utils.ngxBase64(imageData);

        if (base64url === null || base64url === '') {
          alert('Something went wrong with image');
        } else {
          this.shipImageURL = base64url;
        }
      } catch (error) {
        return 'something went wrong';
      }
    } else {
      this.deckImageName = imageData.name;

      for (var i = this.decks.length - 1; i < this.decks.length; i++) {
        this.decks[i].deckImageName = this.deckImageName;
        this.decks[i].deckImageURL = this.deckImageURL;

        //
        return;
      }
    }
  }

  getCordinates() {
    $('#img').on('click', function (event) {
      //
      var x = event.clientX;
      var y = event.pageY;
      //
      return false;
    });

    return false;
  }
  public addDeck(deckLength: number) {
    //
    $('#deckname').empty();
    $('#deckimage').empty();

    if (deckLength < 1) {
      if (this.decks[deckLength].deckName === '' || this.decks[deckLength].deckName.length < 1) {
        // $("#deckname").text(`Enter deck Name`);
        alert('Enter deck Name');
        return;
      } else if (this.decks[deckLength].deckImageName === '') {
        // $("#deckimage").text('Select Deck Image First');
        alert("Select Deck Image First'");
        return;
      }
    } else {
      this.decks.push({
        deckName: '',
        deckImageName: '',
        deckImageURL: '',
        heights: {
          h1: 0,
          h2: 0,
          h3: 0,
          h4: 0,
          h5: 0,
          h6: 0,
        },
      });

      //
      this.deckLength++;
    }
  }

  validateShipName() {
    if (this.shipName === null || this.shipName.toString().length < 1) {
      this.shipValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.shipValidationMsg = '';
      return true;
    }
  }

  public deleteDeck(deckID: number) {
    this.decks.forEach((deck, index) => {
      // if (deck.deckId === deckID) {
      this.decks.splice(index, 1);
      // }
    });
    //
  }

  changeTabs(tab: any) {
    this.$emit('switchTabFunction', 'shiplist');
  }

  _saveHandler() {
    const errorMsg = 'This field is required';

    $('#shipname').empty();
    $('#shipimage').empty();
    $('#deckname').empty();
    $('#deckimage').empty();
    $('#heights').empty();

    if (this.shipName === '' || this.shipName.length < 1) {
      $('#shipname').text(`${errorMsg}`);
      return;
    } else if (this.shipImageName === '') {
      $('#shipimage').text(`Select ship image first`);
      return;
    }

    for (var i = 0; i <= this.decks.length; i++) {
      if (this.decks[i].deckName === '' || this.decks[i].deckName.length < 3) {
        $('#deckname').text(`${errorMsg}`);
        return;
      } else if (this.decks[i].deckImageName === '') {
        $('#deckimage').text('Select deck image first');
        return;
      }

      // else if(this.decks[i].heights.h1<1 || this.decks[i].heights.h2<1  || this.decks[i].heights.h3<1 || this.decks[i].heights.h4<1 || this.decks[i].heights.h5<1 ||this.decks[i].heights.h6<1)
      // {
      //   $("#heights").text('select deck height');

      //   }
      else {
        localStorage.setItem('shipImage', this.shipImageURL);
        this._formReset();

        this.changeTabs('shiplist');
      }
    }
  }

  _formReset() {
    this.shipName = '';
    this.commentOnShip = '';
    this.shipImageName = '';
    this.decks.forEach((data, index) => {
      this.decks[index].deckName == '';
      this.decks[index].deckImageName = '';
      this.decks[index].deckImageURL = '';
    });
  }
}
